<template>
  <div>
    <h1 class="font-semibold mx-auto text-center text-xl">{{$t('EmptyCart')}}!</h1>
    <p class="text-center px-6 pt-4">
      Lass dich von unserer großen Auswahl inspirieren und fülle ihn mit deinen neuen Wohnlieblingen oder melde dich in deinem Kundenkonto an, um deine ggf.
      bereits hinzugefügten Produkte zu sehen.
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>